module.exports = __webpack_public_path__ + "ed20a24ecdf68dfd20b59736aa2b970e.pdf";